<template>
  <div>
    <section class="container-fluid my-4">
      <h4 class="my-4">Relação de todos os <strong>Cursos</strong></h4>

      <div class="well mb-4">
        <input
          type="text"
          class="form-control"
          placeholder="Filtrar a lista abaixo"
          v-model="search"
        />
      </div>

      <table class="table table-bordered table-striped table-hover">
        <thead>
          <tr>
            <th><a href="#" @click="sort($event, 'id')">#</a></th>
            <th><a href="#" @click="sort($event, 'name')">Nome</a></th>

            <th>Ensino</th>
            <th>Vínculos</th>
            <th>Criado</th>
            <th width="98px"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in items" :key="item.id">
            <td>{{ item.id }}</td>
            <td>{{ item.name | uppercase }}</td>
            <td>{{ item.teaching ? item.teaching.name : "" | uppercase }}</td>
            <td class="course-links">
              <span v-if="links(item).length === 0" class="text-muted">Nenhum</span>
              <span
                v-for="link in links(item)"
                :key="link"
                class="badge bg-light text-dark border me-1 mb-1"
              >{{ link }}</span>
            </td>
            <td>{{ item.created_at }}</td>
            <td>
              <ButtonEdit :to="{ name: 'course-edit', params: { id: item.id } }"/>
              <ButtonDelete
                v-if="links(item).length === 0"
                @delete="handlerDelete(item.id, 'courses')"
              />
            </td>
          </tr>
        </tbody>
      </table>

      <Pagination :source="pagination" @navigate="navigate" />
    </section>
  </div>
</template>
  
  <script>
import api from "@/services";
import Pagination from "@/components/Pagination.vue";
import ButtonEdit from "@/components/ButtonEdit.vue";
import ButtonDelete from "@/components/ButtonDelete.vue";
import { serialize, handlerDelete } from "@/helpers";
import Modal from "@/components/Modal.vue";

export default {
  name: "CourseList",
  components: {
    Pagination,
    Modal,
    ButtonEdit,
    ButtonDelete
  },
  data() {
    return {
      sortProperty: "id",
      sortDirection: 1,
      search: "",
      pagination: {},
      items: [],
      handlerDelete
    };
  },
  methods: {
    sort(ev, property) {
      ev.preventDefault();
      this.sortProperty = property;
      this.sortDirection = this.sortDirection ? 0 : 1;
      this.getItens();
    },
    navigate(page) {
      this.getItens(page);
    },
    links(item) {
      const rows = [
        [item.grids_count, "grade", "grades"],
        [item.teams_count, "turma", "turmas"],
        [item.registrations_count, "matrícula", "matrículas"],
        [item.grid_templates_count, "item de grade", "itens de grade"],
        [item.candidates_count, "candidato", "candidatos"],
      ];

      return rows
        .filter(([count]) => Number(count) > 0)
        .map(([count, one, many]) => {
          const total = Number(count);
          return `${total} ${total === 1 ? one : many}`;
        });
    },
    async getItens(page = 1) {
      let query = serialize({
        search: this.search,
        sortDesc: this.sortDirection,
        sortBy: this.sortProperty,
      });

      let uri = `/courses?page=${page}` + query;

      await api.get(uri).then((res) => {
        this.items = res.data.data;
        this.pagination = res.data;
      });
    },
  },
  mounted() {
    this.getItens();
  },
  watch: {
    async search(ev) {
      this.getItens();
    },
  },
};
</script>
  
  <style scoped>
.course-links {
  min-width: 220px;
  white-space: normal;
}

.course-links .badge {
  font-weight: 500;
}
</style>